import * as React from 'react';
import TwoColRow from './TwoColRow';
import { Hr, Paragraph } from '../../../../elements';
const NameChangeRow = ({ value, i18n, formatDate }) => (React.createElement(React.Fragment, null,
    value.changes.map((item, index) => (React.createElement(React.Fragment, { key: index },
        React.createElement(TwoColRow, { label: i18n('common.from'), value: item.from }),
        React.createElement(TwoColRow, { label: i18n('common.to'), value: item.to }),
        item.date && (React.createElement(TwoColRow, { label: i18n('common.date'), value: formatDate(item.date) })),
        React.createElement(Hr, null)))),
    React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('stateauthority.taxAgency')} (${formatDate(value.verificationDate)})` }),
    value.comment !== '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--large' },
        React.createElement(Paragraph, { bold: true }, i18n('common.note')),
        React.createElement("div", { className: 'ReadReportContent__NotationContent' },
            React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
export default NameChangeRow;
